import { IQuantity } from 'Data/ViewModels/Core/IQuantity';

export enum PenetrationDepthMeasuredBy {
  MetreScale = 'MetreScale',
  GraduationsAtUniformIntervals = 'GraduationsAtUniformIntervals',
}

export enum MoistureCondition {
  Dry = 'Dry',
  Wet = 'Wet',
  MoistureContent = 'MoistureContent',
}

export enum TestCompletion {
  InProgress = 'InProgress',
  TestComplete = 'TestComplete',
  TestStopped = 'TestStopped',
}

export interface Measurement {
  Blows?: number;
  TotalBlows?: number;
  PenetrationReading?: IQuantity;
  DepthReading?: IQuantity;
  ExtensionUsed?: boolean;
  Offset?: number;
  Penetration?: IQuantity;
  Depth?: IQuantity;
}
